<template>
   <div class="card h-80vh w-80vw md:w-40vw  shadow-pop-bl">
    <div class="image relative w-full h-full overflow-hidden">
      <img class="w-full h-full" :src="require('@/assets/images/contact/' + dataModal.image)"/>
      <span class="absolute text-white button-hover-me
        rounded-xl p-2 flex w-full h-full top-0 left-0 justify-center items-center">
        <img src="@/assets/images/imagen.png" class="absolute w-full h-full object-cover opacity-50"
          alt="Jesus Varela">
        {{$t('hover-me')}}
        <font-awesome-icon  class="text-gray-300 text-lg ml-2" icon="hand-pointer" />
      </span>
    </div>
    <div class="details bg-site-500 absolute top-0 left-0 h-full w-3/4">
      <div class="center bg-white shadow-lg top-1/2 absolute text-center p-4 w-full">
        <h2 class="text-6xl text-site-400 ">
          {{$t(dataModal.title)}}<br>
          <span class="text-4xl text-site-300">{{dataModal.subtitle}}</span>
        </h2>
        <p class="text-site-300 py-4">
          {{$t(dataModal.description)}}
        </p>
        <social-section class="flex justify-center flex-wrap"
         :social="socialMedia"
         icon-class="text-4xl px-1 cursor-pointer"
         img-class="w-10 h-10 text-center">
         </social-section>
      </div>
    </div>
  </div>
</template>
<script>
import SocialSection from '@/components/SocialSection.vue';

export default {
  name: 'ContentCard',
  props: {
    dataModal: {
      type: Object,
      required: true,
    },
    socialMedia: {
      type: Array,
      required: true,
    },
  },
  components: {
    SocialSection,
  },
};
</script>
<style scoped>
.card {
    transform: translate(-50%,-50%);
    background: #000;
}
.card .image img {
    transition: .5s;
}
.card:hover .image img {
    opacity: .5;
    transform: translateX(25%);/*100%*/
}
.card .details {
    transition: .5s;
    transform-origin: left;
    transform: perspective(2000px) rotateY(-90deg);
}
.card:hover .details {
    transform: perspective(2000px) rotateY(0deg);
}
.card .details .center {
    transform: translateY(-50%);
}

</style>
